import React, { useState, useEffect } from "react";

const BaseModal = ({ title, show, onClose, onSave, fields, initialData }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (show) {
            setFormData(initialData || {}); // 기존 데이터 유지 또는 초기화
        }
    }, [show, initialData]);

    // 입력값 변경 핸들러
    const handleChange = (e, field) => {
        const value = e.target.value;
        setFormData((prev) => ({
            ...prev,
            [field.name]: value,
        }));
    };

    return (
        <div className={`modal fade ${show ? "show d-block" : "d-none"}`} tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {fields.map((field) => (
                            <div key={field.name} className="form-floating mb-3 position-relative">
                                <input
                                    type={field.type}
                                    className="form-control"
                                    name={field.name}
                                    value={formData[field.name] || ""}
                                    onChange={(e) => handleChange(e, field)}
                                    placeholder={field.placeholder}
                                />
                                {field.type !== "hidden" && <label htmlFor={field.name}>{field.label}</label>}
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            닫기
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => onSave(formData)}>
                            저장
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BaseModal;
